/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cv_Extract_Form_Enum_Event_Tourism_Hospitality23Inputs */

const en_cv_extract_form_enum_event_tourism_hospitality23 = /** @type {(inputs: Cv_Extract_Form_Enum_Event_Tourism_Hospitality23Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event, Tourism and Hospitality`)
};

const de_cv_extract_form_enum_event_tourism_hospitality23 = /** @type {(inputs: Cv_Extract_Form_Enum_Event_Tourism_Hospitality23Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veranstaltung, Tourismus und Gastgewerbe`)
};

/**
* | output |
* | --- |
* | "Event, Tourism and Hospitality" |
*
* @param {Cv_Extract_Form_Enum_Event_Tourism_Hospitality23Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const cv_extract_form_enum_event_tourism_hospitality23 = /** @type {((inputs?: Cv_Extract_Form_Enum_Event_Tourism_Hospitality23Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Extract_Form_Enum_Event_Tourism_Hospitality23Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cv_extract_form_enum_event_tourism_hospitality23(inputs)
	return en_cv_extract_form_enum_event_tourism_hospitality23(inputs)
});
export { cv_extract_form_enum_event_tourism_hospitality23 as "cv_extract_form_enum_EVENT_TOURISM_HOSPITALITY" }